import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/schology/transform-back.webp";

function Transformschology() {
  return (
    <section className="transform-schology p-100 text_white">
      <Container>
        <div
          className="transform-box"
          style={{
            backgroundImage: `url(${BgImg})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <Row className="mb-4 mb-md-5">
            <Col
              xs={12}
              md={12}
              lg={12}
              xl={8}
              xxl={8}
              className="m-auto text-center"
            >
              <h2>
                Ready to <span className="white-box">Transform</span> Education
              </h2>
              <h3 style={{ color: "#fff" }}>
                Partner with Tekrevol to build your unified platform and shape
                the future of learning.
              </h3>
            </Col>
          </Row>

          <Row>
            <Col
              xs={12}
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              className="text-center"
            >
              <StaticImage
                src="../../../images/case-studies/schology/transform-img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1491}
                height={604}
              />
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default Transformschology;
